module.exports = __webpack_public_path__ + "fonts/67c84cd.otf";